import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import RoleSelectionScreen from './RoleSelectionScreen'; // import your screen
import RiderLogin from './RiderLogin';
import GuestLogin from './GuestLogin';
import RiderMap from './RiderMap';
import TripDetailsScreen from './TripDetailsScreen';
import TripTrackingScreen from './TripTrackingScreen';
import RideHistoryScreen from './RideHistoryScreen';
import RiderRegisterScreen from './RiderRegisterScreen';
import AdminPanel from './AdminPanel';





function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RoleSelectionScreen />} />
        <Route path="/riderLogin" element={<RiderLogin />} />
        <Route path="/guestLogin" element={<GuestLogin />} />
        <Route path="/map" element={<RiderMap />} />
        <Route path="/tripDetails" element={<TripDetailsScreen />} />
        <Route path="/testTrip" element={<TripDetailsScreen />} />
        <Route path="/trip-tracking" element ={<TripTrackingScreen />} />
        <Route path="/ride-history" element={<RideHistoryScreen />} />
        <Route path="/RiderRegisterScreen" element = {<RiderRegisterScreen />} />
        <Route path="/admin" element={<AdminPanel />} />



      </Routes>
    </Router>
  );
}


export default App;
